// Per-browser daily cap on streamed (mic-on) time — a generous limit to stop honest
// runaway use / casual over-play from racking up Deepgram minutes. Tracked in localStorage
// keyed by date, so it resets each day. Circumventable (clear storage), but the relay's
// per-connection cap is the robust backstop; this is the friendly "that's enough for today".

export const DAILY_CAP_MS = 60 * 60 * 1000 // 60 min of streamed audio per browser per day

const key = (): string => 'labs_stream_' + new Date().toISOString().slice(0, 10) // per UTC day

export function streamedTodayMs(): number {
  try {
    return parseInt(localStorage.getItem(key()) || '0', 10) || 0
  } catch {
    return 0
  }
}

export function addStreamedMs(ms: number): void {
  if (!ms || ms < 0) return
  try {
    localStorage.setItem(key(), String(streamedTodayMs() + Math.round(ms)))
  } catch {
    /* private mode — best effort */
  }
}

export function overDailyCap(): boolean {
  return streamedTodayMs() >= DAILY_CAP_MS
}
